import styled, { css } from 'styled-components';

const ListWrapper = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;

  ${({ $variant }) => $variant === 'horizontal' && css`
    display: flex;
    gap: 1rem;
    flex-direction: column;

    @media all and (min-width: ${({ theme }) => theme.breakingpoints.sm}) {
      flex-direction: row;
      flex-wrap: wrap;
    }
    @media all and (min-width: ${({ theme }) => theme.breakingpoints.lg}) {
      justify-content: space-between;
      flex-wrap: nowrap;
    }
  `}
`;

export default ListWrapper;
